import React from "react";
import ImageUploadField from "./ImageUploadField";
import VideoUploadField from "./VideoUploadField";

const GALLERY_CATEGORIES = [["public", "Public Events"], ["speeches", "Speeches"], ["meetings", "Meetings"]];
const VIDEO_CATEGORIES = [["speeches", "Speeches"], ["interviews", "Interviews"], ["campaigns", "Campaigns"], ["press", "Press"]];
const emptyPhoto = { url: "", title: "", title_np: "", category: "public" };
const emptyVideo = { title: "", title_np: "", description: "", description_np: "", url: "", thumbnail: "", category: "speeches" };

export default function PoliticalGalleryTab({ gallery, setGallery, videos, setVideos, personaluid }) {
    const upd = (list, setList, i, patch) => {
        const c = [...list];
        c[i] = { ...c[i], ...patch };
        setList(c);
    };
    const removeAt = (list, setList, i) => setList(list.filter((_, idx) => idx !== i));

    return (
        <div>
            {/* ---------- Photo gallery ---------- */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Photo Gallery <small className="text-muted fw-normal">(category + caption; visitors can filter and open a lightbox)</small></span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setGallery([...gallery, { ...emptyPhoto }])}>
                        <i className="bi bi-plus-lg me-1" />Add Photo
                    </button>
                </div>
                <div className="card-body">
                    {gallery.length === 0 ? (
                        <p className="text-muted mb-0">No photos in gallery yet.</p>
                    ) : (
                        <div className="row g-3">
                            {gallery.map((g, i) => (
                                <div className="col-md-4" key={i}>
                                    <div className="border rounded p-2 h-100">
                                        <ImageUploadField value={g.url} onChange={(v) => upd(gallery, setGallery, i, { url: v })} purpose="gallery" personaluid={personaluid} placeholder="Upload photo" />
                                        <select className="form-select form-select-sm mt-2" value={g.category || "public"} onChange={(e) => upd(gallery, setGallery, i, { category: e.target.value })}>
                                            {GALLERY_CATEGORIES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                                        </select>
                                        <input className="form-control form-control-sm mt-2" placeholder="Caption" value={g.title || ""} onChange={(e) => upd(gallery, setGallery, i, { title: e.target.value })} />
                                        <input className="form-control form-control-sm mt-2" placeholder="क्याप्सन (Nepali)" value={g.title_np || ""} onChange={(e) => upd(gallery, setGallery, i, { title_np: e.target.value })} />
                                        <button type="button" className="btn btn-sm btn-outline-danger mt-2 w-100" onClick={() => removeAt(gallery, setGallery, i)}>
                                            <i className="bi bi-trash me-1" />Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* ---------- Videos ---------- */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Videos <small className="text-muted fw-normal">(YouTube link or uploaded file; plays in a pop-up)</small></span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setVideos([...videos, { ...emptyVideo }])}>
                        <i className="bi bi-plus-lg me-1" />Add Video
                    </button>
                </div>
                <div className="card-body">
                    {videos.length === 0 ? (
                        <p className="text-muted mb-0">No videos yet.</p>
                    ) : videos.map((v, i) => (
                        <div className="border rounded p-3 mb-3" key={i}>
                            <div className="row g-2">
                                <div className="col-md-8">
                                    <label className="form-label small text-muted">YouTube link</label>
                                    <input className="form-control form-control-sm" placeholder="https://www.youtube.com/watch?v=..." value={v.url || ""} onChange={(e) => upd(videos, setVideos, i, { url: e.target.value })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small text-muted">Category</label>
                                    <select className="form-select form-select-sm" value={v.category || "speeches"} onChange={(e) => upd(videos, setVideos, i, { category: e.target.value })}>
                                        {VIDEO_CATEGORIES.map(([val, l]) => <option key={val} value={val}>{l}</option>)}
                                    </select>
                                </div>
                                <div className="col-md-1 d-flex align-items-end">
                                    <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeAt(videos, setVideos, i)}><i className="bi bi-trash" /></button>
                                </div>
                                <div className="col-12">
                                    <label className="form-label small text-muted">…or upload a video file</label>
                                    <VideoUploadField value={/^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\//i.test(v.url || "") ? "" : v.url} onChange={(val) => upd(videos, setVideos, i, { url: val })} personaluid={personaluid} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Title</label>
                                    <input className="form-control form-control-sm" value={v.title || ""} onChange={(e) => upd(videos, setVideos, i, { title: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">शीर्षक (Nepali)</label>
                                    <input className="form-control form-control-sm" value={v.title_np || ""} onChange={(e) => upd(videos, setVideos, i, { title_np: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Description</label>
                                    <input className="form-control form-control-sm" value={v.description || ""} onChange={(e) => upd(videos, setVideos, i, { description: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">विवरण (Nepali)</label>
                                    <input className="form-control form-control-sm" value={v.description_np || ""} onChange={(e) => upd(videos, setVideos, i, { description_np: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small text-muted">Thumbnail <span className="text-muted">(optional — YouTube videos get one automatically)</span></label>
                                    <ImageUploadField value={v.thumbnail || ""} onChange={(val) => upd(videos, setVideos, i, { thumbnail: val })} purpose="gallery" personaluid={personaluid} placeholder="Upload thumbnail" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}